//angular imports
import { 
  ChangeDetectionStrategy, 
  Component,  
  Signal, 
  WritableSignal, 
  computed,
  signal, 
} from '@angular/core';

//local imports
import { Messenger } from '@app/shared';
import { UserLoggedInMessage } from '@core/messages';
import { ClosePlatformDialogMessage, ShowPlatformDialogMessage } from '@app/components/notification';

// export class UserHeader {
//   username: Signal<string> = signal<string>('');
// }

export class UserDialogModel {}

@Component({
    selector: 'current-user-header',
    templateUrl: './current-user-header.component.html',
    styleUrl: './current-user-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CurrentUserHeaderComponent  {

  private userLoggedIn: Signal<UserLoggedInMessage>;
  private isOpen: WritableSignal<boolean> = signal<boolean>(false);

  public username = computed(() =>
  {
     let loggedInMsg = this.userLoggedIn();
     
     console.log('current-user-header', loggedInMsg);
     return loggedInMsg?.User?.name;
  });

  constructor(
    private messenger: Messenger) {

    this.userLoggedIn = this.messenger.getSignal(UserLoggedInMessage);

    this.messenger.subscribe(this, ShowPlatformDialogMessage,
      message => {
        this.isOpen.set(message.content instanceof UserDialogModel);
      });

    this.messenger.subscribe(this, ClosePlatformDialogMessage,
      message => {
          this.isOpen.set(false);
    });
  }

  public toggle() {
    console.log('current-user-header','toggle');
    // Logic to open notifications can be added here
    if(!this.isOpen()) {      
      this.messenger.send(ShowPlatformDialogMessage.create(new UserDialogModel()));
    }else{      
      this.messenger.send(new ClosePlatformDialogMessage());
    }
  }

}


